<template>
  <div id="subscribe-list">

    <div class="card" @click="toSiteInfo(list.id)" v-for="(list, index) in siteLists" :key="index">
      <div class="head">
        <!-- 地点&时间 -->
        <div class="location-time">
          <p>{{list.station_name}}</p>
          <p>
            <img src="images/car_wash/position.png" alt="">
            {{list.station_address}}
          </p>
        </div>
      </div>
      <!-- 分割线 -->
      <div class="divider">
<!--        <p>当前状态</p>-->
      </div>
      <div class="tail">
        <!-- 当前叫号  -->
<!--        <div>-->
<!--          <p>当前叫号</p>-->
<!--          <p>{{'JL001'}}</p>-->
<!--        </div>-->
        <!-- 等待人数  -->
        <div>
          <p>等待人数</p>
          <p>{{list.count}}</p>
        </div>
        <!-- 预计等待时间   -->
        <div>
          <p>预计等待时间</p>
          <p>{{list.count*5}}分钟</p>
        </div>
      </div>
    </div>

    <div style="height: 19.733vw;"></div>
    <div class="bottom-button">
      <div class="my-subscribe" @click="toMySubscribe">我的预约</div>
      <div class="my-ticket" @click="toMyTicket">我的洗车券</div>
    </div>
<!--    <div class="my-subscribe" @click="toMySubscribe">我的预约</div>-->

  </div>
</template>

<script>
  import { getSubscribeList } from '@/apis/car_wash'

  export default {
    name: "subscribeList",
    data() {
      return {
        siteLists:[] // 站点列表
      }
    },
    methods:{
      // 跳转到我的预约( my_subscribe )
      toMySubscribe() {
        this.$router.push('/my_subscribe')
      },
      // 跳转到我的洗车券
      toMyTicket() {
        this.$router.push('/my_ticket')
      },
      // 跳转到站点详情
      toSiteInfo(id) {
        this.$router.push({name: `wash_info`, query: {id}})
      }
    },
    mounted() {
      // 获取预约列表
      getSubscribeList().then((res) => {
        console.log(res)
        this.siteLists = res.data
      })
    },
  }
</script>

<style scoped>
  #subscribe-list{
    padding-top: 2.667vw;
  }
  .card{
    width: 92vw;
    /*height: 38.667vw;*/
    /*box-shadow: 0 1.333vw 6.667vw 0 rgba(191, 194, 204, 0.4);*/
    border-radius: 2.933vw;
    margin: 0 auto 4vw;
    overflow: hidden;
    background: #fbfbfb;
  }
  .head{
    display: flex;
    justify-content: space-between;
    /*align-items: center;*/
    box-sizing: border-box;
    padding: 5vw 4.133vw 0;
  }
  /*地点&时间*/
  .location-time img{
    width: 2.933vw;
    height: 3.733vw;
    padding-right: 1vw;
    flex-shrink: 0;
  }
  .location-time>p:first-child{
    font-size: 4.533vw;
    margin-bottom: 2vw;
    color: #303133;
    font-weight: bold;
  }
  .location-time>p:last-child{
    font-size: 3.467vw;
    color: #909399;
    /*line-height: 7vw;*/
    display: flex;
    /*align-items: center;*/
    /*max-width: 62vw;*/
  }
  /* 分割线 */
  .divider{
    width: 84.133vw;
    height: 0;
    margin: 0 auto;
    font-size: 3.467vw;
    color: #bfc2cc;
    border-top: 1px dashed #edefe2;
    margin-top: 3.7vw;
  }
  .divider>p{
    width: 16vw;
    height: 4vw;
    text-align: center;
    background: #ffffff;
    position: relative;
    top: -2vw;
    left: 3vw;
  }
  .tail{
    display: flex;
    margin: 6vw 3.5vw 5vw;
  }
  .tail>div{
    width: 50%;
    text-align: center;
    font-size: 3.733vw;
  }
  /*.tail>div:first-child{*/
  /*  width: 20%;*/
  /*  margin-right: 13vw;*/
  /*}*/
  /*.tail>div:nth-child(2){*/
  /*  width: 20%;*/
  /*  margin-right: 10vw;*/
  /*}*/
  /*.tail>div:last-child{*/
  /*  width: 30%;*/
  /*}*/
  .tail>div>p:first-child{
    color: #606266;
  }
  .tail>div>p:last-child{
    margin-top: 2vw;
    color: #00d10b;
  }
  .bottom-button{
    width: 100%;
    background: #ffffff;
    box-sizing: border-box;
    padding: 4vw;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
  }
  .my-ticket{
    width: 36vw;
    height: 11.733vw;
    box-sizing: border-box;
    border: 0.133vw solid #096c47;
    border-radius: 1.067vw;
    display: flex;
    justify-content: center;
    line-height: 11.733vw;
    color: #096c47;
    font-weight: bold;
  }
  .my-subscribe{
    width: 53.067vw;
    height: 11.733vw;
    border-radius: 1.067vw;
    display: flex;
    justify-content: center;
    line-height: 11.733vw;
    background: #096c47;
    color: #fefefe;
    font-weight: bold;
  }

</style>
